import React, { useEffect, useState } from 'react'
import './menu-mobile.scss'
import { useStaticQuery, graphql } from "gatsby"
import { utilGtm } from '../../../utils/utilGtm'
import iconRigth from '../../../assets/images/icons/icon-arrow-rigth.svg';
import siteUrl from '../../../utils/siteUrl'
import Redirect from '../../atoms/redirect/redirect'

const MenuMobile = props => {
    const { setmobileMenuActive } = props

    const { allContentfulMenu, contentfulHome } = useStaticQuery(graphql`
        query {
            allContentfulMenu(filter: {slug: {eq: "menu-de-navegacion"}}) {
                nodes {
                    nombre
                    slug
                    itemMenu {
                        titulo
                        slug
                        itemsMenu {
                            titulo
                            slug
                        }
                    }
                }
            }
            contentfulHome {
                segmentos {
                    nombre
                    slug
                    categorias {
                        slug
                        nombre
                    }
                }
            }
            
        }
        `)

    const navigationList = allContentfulMenu.nodes[0].itemMenu
    
    const itemCategory = 'productos' ;

    const allSegments = contentfulHome.segmentos;
    const [segmentActive, setSegmentActive] = useState(null);
    const [opened, setopened] = useState(false)
    const [activeCollapse, setactiveCollapse] = useState(-1)

    useEffect(() => {
        setopened(true)
        if(allSegments.length > 0){
            setSegmentActive(allSegments[ getSectionActive() ]);
        }
    }, [])

    const getSectionActive = () => {
        var slugs = window.location.pathname.split('/');
        var section = (slugs.length > 1) ? slugs[1] : '';
        var index = allSegments.findIndex( s => s.slug === section );
        
        return (index !== -1) ? index : 0;
    }

    const handleClose = () => {
        setopened(false)
        setTimeout(() => {
            setmobileMenuActive(false)
        }, 300);
    }

    const handleClickMenuItem = (index, subItems, slug) => {
        if (index === activeCollapse) {
            setactiveCollapse(-1)
        } else if (subItems) {
            setactiveCollapse(index)
        } else if(slug === itemCategory){
            setactiveCollapse(index)
        } else if(slug){            
            window.location.href = siteUrl + '/' + slug + '/'
        } else{
            window.location.href = siteUrl + '/'
        }
    }

    const handleClickScroll = () => {
        document.getElementById('segment-list').scrollLeft = document.body.offsetWidth;
    }

    return (
        <div className={"o-menu-mobile " + (opened ? 'active' : '')}>
            <div className="o-menu-mobile-info">
                <div className="o-menu-mobile_segments-list-container">
                    <div className="o-menu-mobile_segments-list" id="segment-list">
                        {
                            allSegments.map((menu, index)=>(
                                <div 
                                    className={
                                        "o-menu-mobile_segment-item " + 
                                        ( segmentActive && menu.slug === segmentActive.slug ? 'active' : '' ) +
                                        utilGtm('gtmHomeClicHeader', menu.slug)
                                    } 
                                    key={ index }
                                    onClick={ ()=>{ handleClickMenuItem(0, null, menu.slug) } }
                                >
                                    { menu.nombre }
                                </div>
                            ))
                        }
                    </div>
                    {
                        allSegments.length > 3 &&
                        <div className="o-menu-mobile_segment-show-more" onClick={ ()=>{ handleClickScroll() } }>
                            <img src={ iconRigth } alt="icon-rigth"/>
                        </div>
                    }
                
                </div>
                <div className="o-menu-mobile_collapse-list">
                    { 
                        navigationList.map((item, index) => {
                            return (
                                <div className={"o-menu-mobile_collapse-item " + ( activeCollapse == index ? 'active' : '')} key={ index }>
                                    <div className={"o-menu-mobile_collapse-item-title" }>
                                        <input type="radio" name="tab" id={index + "-check"} onClick={() => { handleClickMenuItem(index, item.itemsMenu, item.slug) }} />
                                        <label className="o-menu-mobile_collapse-item-label" htmlFor={index + "-check"}>
                                            {item.titulo}
                                            {
                                                (item.itemsMenu !== null || item.slug === itemCategory) &&
                                                <i className="o-icon fal fa-chevron-down"></i>
                                            }
                                        </label>
                                    </div>
                                    {   
                                        item.slug == itemCategory ?
                                        <div className="o-menu-mobile_list-subitems">
                                            {
                                                segmentActive &&
                                                segmentActive.categorias.map((category, index) => (
                                                    <Redirect url={ `${ segmentActive.slug }/${category.slug}` } className="o-menu-mobile_subitem" key={ index }>
                                                        {category.nombre}
                                                        <i className="o-icon fal fa-chevron-left"></i>
                                                    </Redirect>
                                                ))
                                            }
                                            {
                                                item.itemsMenu &&
                                                item.itemsMenu.map((subitem, subindex) => (
                                                    <Redirect url={ subitem.slug } className="o-menu-mobile_subitem" key={ subindex }>
                                                        {subitem.titulo}
                                                        <i className="o-icon fal fa-chevron-left"></i>
                                                    </Redirect>
                                                ))
                                            }
                                        </div> :                                     
                                        item.itemsMenu ?
                                        <div className="o-menu-mobile_list-subitems">
                                            {
                                                item.itemsMenu.map((subitem, subindex) => (
                                                    <Redirect url={ subitem.slug } className="o-menu-mobile_subitem" key={ subindex }>
                                                        {subitem.titulo}
                                                        <i className="o-icon fal fa-chevron-left"></i>
                                                    </Redirect>
                                                ))
                                            }
                                        </div>
                                        :  <div></div>

                                    }
                                </div>
                            )
                        })
                    }
                </div>
            </div>
        </div>
    )
}

export default MenuMobile
